import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import CompetitorForm from './CompetitorForm'
import { updateCompetitor } from '../services'
import { handleError } from '../../../helpers'

export default function EditCompetitorModal({ visible, onClose, competitor, reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm()

	const onSubmit = values => {
		if(values.code === competitor.code) delete values.code
		updateCompetitor(competitor.id, values)
			.then(() => {
				message.success('Competidor actualizado exitosamente.')
				reset()
				reload()
				onClose()
			})
			.catch(error => handleError(error))
	}	

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Competidor</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<CompetitorForm competitor={competitor} register={register} errors={errors} />
						<Button type="submit" color="primary">Actualizar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}